export default "__VITE_ASSET__CbXyqER9__"